// @flow

import * as React from 'react';
import Button from './button';

type Props = {
  startDate: string,
  widgetName: string,
  projectId: any,
};

const styles: Object = {
  button: {
    background: '#fff',
    border: '1px solid #b3b3b3',
    fontSize: '0.8rem',
    padding: '0.3rem 0.7rem',
    cursor: 'pointer',
    color: '#616161',
    float: 'right',
    transition: 'border-color 0.2s',
    ':hover': {
      borderColor: '#737373',
    },
  },
};
// FX-99 (GATE-099): the legacy insights export exists only on these three hosts. On any other host (production's
// insights.app.leanplando.com included) there is nothing to export to, and the old fallback sent users to
// an unregistered legacy domain (see FX-99); so the button is not shown there.
const LEGACY_EXPORT_HOSTS: { [string]: string } = {
  'insights.theplando.com': 'https://theplando.com',
  'insights.qa.theplando.com': 'https://qa.theplando.com',
  'insights.leanplando.com': 'https://leanplando.com',
};

export function legacyExportBaseUrl(host: string): ?string {
  return LEGACY_EXPORT_HOSTS[host] || null;
}

class ExportButton extends React.Component<Props> {
  downloadFile() {
    const base: ?string = legacyExportBaseUrl(window.location.host);
    if (base && this.props.projectId !== undefined && this.props.projectId !== null) {
      window.open(`${base}/projects/${this.props.projectId}/insights/export?start_date=${this.props.startDate}&widget_name=${this.props.widgetName}&cmd=export_insights`, '_blank');
    }
  }

  render(): React.Node {
    if (!legacyExportBaseUrl(window.location.host)) {
      return null;
    }
    return (
      <Button style={styles.button} onClick={this.downloadFile.bind(this)}>Export</Button>
    );
  }
}

export default ExportButton;
